import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Card, Empty, Spinner } from "@/components/UIKit";
import StatusBadge from "@/components/StatusBadge";
import { fmtKwh } from "@/lib/format";
import { Link } from "react-router-dom";
import { Zap, Search } from "lucide-react";

export default function Malepunkter() {
  const [items, setItems] = useState(null);
  const [total, setTotal] = useState(0);
  const [q, setQ] = useState("");

  useEffect(() => {
    const t = setTimeout(async () => {
      setItems(null);
      const params = new URLSearchParams({ limit: "100" });
      if (q) params.set("q", q);
      const { data } = await api.get(`/metering-points?${params}`);
      setItems(data.items); setTotal(data.total);
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div data-testid="malepunkter-page">
      <PageHeader title="Målepunkter" subtitle={`${total} målepunkter i drift`} />

      <div className="relative max-w-lg mb-4">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-500" />
        <input
          value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Søk MPID, adresse, målernr…"
          className="w-full h-9 pl-9 pr-3 rounded-md bg-zinc-900/60 border border-zinc-900 focus:border-zinc-800 text-sm text-zinc-100 focus:outline-none"
          data-testid="mp-search"
        />
      </div>

      <Card className="overflow-hidden">
        {items === null ? <div className="p-8"><Spinner /></div>
          : items.length === 0 ? <Empty title="Ingen målepunkter" />
          : (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[11px] uppercase tracking-wider text-zinc-500 bg-zinc-950/60 sticky top-0">
                <th className="py-2.5 px-4 font-medium">MPID</th>
                <th className="py-2.5 px-4 font-medium">Kunde</th>
                <th className="py-2.5 px-4 font-medium">Nettselskap</th>
                <th className="py-2.5 px-4 font-medium">Adresse</th>
                <th className="py-2.5 px-4 font-medium">Prisområde</th>
                <th className="py-2.5 px-4 font-medium">Årsforbruk</th>
                <th className="py-2.5 px-4 font-medium">Status</th>
              </tr>
            </thead>
            <tbody>
              {items.map((mp) => (
                <tr key={mp.id} className="border-t border-zinc-900 hover:bg-zinc-900/40" data-testid={`mp-row-${mp.mpid}`}>
                  <td className="py-2.5 px-4 font-mono text-xs text-emerald-400 flex items-center gap-2">
                    <Zap className="h-3 w-3" /> {mp.mpid}
                  </td>
                  <td className="py-2.5 px-4">
                    <Link to={`/kunder/${mp.customer_id}`} className="text-zinc-100 hover:text-emerald-400">
                      {mp.customer?.full_name || "—"}
                    </Link>
                    <div className="text-[10px] text-zinc-500">{mp.customer?.customer_number}</div>
                  </td>
                  <td className="py-2.5 px-4 text-zinc-300">{mp.grid_company}</td>
                  <td className="py-2.5 px-4 text-zinc-400 text-xs">{mp.address}, {mp.postal_code} {mp.city}</td>
                  <td className="py-2.5 px-4"><span className="text-xs bg-zinc-800 px-1.5 py-0.5 rounded text-zinc-300">{mp.price_area}</span></td>
                  <td className="py-2.5 px-4 tabular-nums text-zinc-300">{fmtKwh(mp.annual_consumption_kwh)}</td>
                  <td className="py-2.5 px-4"><StatusBadge value={mp.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
